import { customerProfiles } from '@/api/index'

export function getSiteTree () {
  return customerProfiles.request({
    method: 'post',
    url: '/getSiteTree',
    iSFromData: true
  })
}
